
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 4.162a2.162 2.162 0 0 1 4.323 0c0 1.193-.968 2.181-2.162 2.181C3.969 6.343 3 5.355 3 4.162ZM20.995 20H21v-6.602c0-3.23-.695-5.717-4.47-5.717-1.816 0-3.034.996-3.531 1.94h-.053V7.982h-3.58v12.017h3.728v-5.95c0-1.567.297-3.082 2.238-3.082 1.911 0 1.94 1.788 1.94 3.182V20h3.724ZM3.297 7.983h3.732V20H3.297V7.983Z","fill":"#161313"}})])
          )
        }
      }
    